<nav class="navbar navbar-expand-lg main-website-header" *ngIf="showHeader" id="sticky-header">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="material-icons text-secondary"> menu </span>
    </button>
    <a routerLink="/"
      class="navbar-brand cursor-pointer black-banner d-flex align-items-center tab-margin-left-10">
      <img src="{{ assetURL }}/assets/images/247invites-logo.png" alt="247Invites" />
    </a>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="input-group input-group-sticky">
        <input type="text" class="form-control"
          placeholder="Search for any invitation template..."
          [(ngModel)]="searchterm" (keypress)="keyPress($event)" />
        <div class="input-group-append">
          <button class="btn btn-secondary bg-pink" type="button"
            (click)="search()">
            <span class="material-icons"> search </span>
          </button>
        </div>
      </div>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown" *ngFor="let item of CategoryData">
          <a class="nav-link dropdown-toggle" id="{{ item.CategoryId }}"
            *ngIf="
          item.SubCategoryData != null &&
          item.SubCategoryData.length > 0
        " id="navbarDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            {{ item.CategoryDesc }}
            <span class="material-icons">expand_more</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" (click)="closeMenu()" [routerLink]="
            '/' + item.CategorySlug
          ">All</a>
            <div *ngFor="let subitem of item.SubCategoryData">
              <a class="dropdown-item" (click)="closeMenu()" [routerLink]="
              '/' + subitem.SubCategorySlug
          ">{{ subitem.SubCategoryName }}</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="ml-auto nav align-items-center top-menu desk-top-menu">
      <li
        class="nav-item d-none d-md-block cursor-pointer d-flex-desktop header-main-item">
        <a routerLink="/user/contactus">Contact</a>
      </li>
      <li
        class="nav-item d-none d-md-block pr-dsk-0 d-flex-desktop header-main-item"
        *ngIf="
          this.userDetails.UserId == undefined ||
          this.userDetails.UserId == null ||
          this.userDetails.UserId == '' ||
          this.userDetails.UserId < 1
        ">
        <a (click)="openDialog()" class="btn-login cursor-pointer">Login</a>
      </li>
      <li class="nav-item d-block d-md-none" *ngIf="
          this.userDetails.UserId == undefined ||
          this.userDetails.UserId == null ||
          this.userDetails.UserId == '' ||
          this.userDetails.UserId < 1
        ">
        <div class="btn-group" ngbDropdown display="dynamic">
          <button class="btn btn-no-style btn-sm" type="button"
            ngbDropdownToggle>
            <img src="{{ assetURL }}/assets/images/login-user.svg" width="100%"
              height="100%" class="user-logo" alt="User-Logo" />
          </button>
          <div id="resourcestitle" ngbDropdownMenu
            aria-labelledby="dropdownBasic1"
            class="dropdown-menu dropdown-menu-right">
            <ul class="list-unstyled">
              <li *ngIf="
                  this.userDetails.UserId == undefined ||
                  this.userDetails.UserId == null ||
                  this.userDetails.UserId == '' ||
                  this.userDetails.UserId < 1
                ">
                <a (click)="redirectToSellerInfo()"
                  class="cursor-pointer gap-5 d-flex align-items-center">
                  <span class="material-icons fs-20 rotate-0">
                    payments
                  </span> Be a Seller</a>
              </li>
              <li class="d-block d-md-none cursor-pointer">
                <a routerLink="/user/contactus"
                  class="cursor-pointer gap-5 d-flex align-items-center">
                  <span class="material-icons fs-20 rotate-0">
                    email
                  </span>
                  Contact Us</a>
              </li>
              <li class="d-block d-md-none cursor-pointer" *ngIf="
                  this.userDetails.UserId == undefined ||
                  this.userDetails.UserId == null ||
                  this.userDetails.UserId == '' ||
                  this.userDetails.UserId < 1
                ">
                <a (click)="openDialog()"
                  class="cursor-pointer gap-5 d-flex align-items-center">
                  <span class="material-icons fs-20 rotate-0">
                    lock
                  </span>
                  Login</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li class="nav-item d-none d-md-block mr-2"
        *ngIf="this.userDetails.UserId > 0">
        <a (click)="MyVideos()"
          class="btn-my-video btn-my-video-pad gap-5 d-flex align-items-center">
          <span class="material-icons fs-20 rotate-0">
            videocam
          </span> My Videos</a>
      </li>
      <li class="nav-item" *ngIf="this.userDetails.UserId > 0">
        <div class="user-area">
          <div class="user-name">
            <div class="form-row align-item-center">
              <div class="col-md-auto pr-0 d-none d-md-block"></div>
              <div class="col-md-auto">
                <span class="d-block member-area">
                  <div class="dropdown">
                    <button class="rounded-circle profile-initials"
                      *ngIf="this.userDetails.UserId > 0"
                      id="dropdownMenuButton" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      {{ getInitials(userDetails?.Name) }}
                    </button>
                    <!-- <img src="{{ ProfileImage }}" *ngIf="this.userDetails.UserId > 0" class="rounded-circle profile-img"
                      alt="Profile Photo" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" /> -->
                    <!-- <button class="btn btn-secondary btn-sm ml-2 d-none d-md-inline-block" type="button">
                      Hello, {{ getInitials(userDetails?.Name) }}
                    </button> -->
                    <div id="resourcestitle"
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-mobile-header dropdown-menu-right">
                      <ul class="list-unstyled">
                        <!-- <li class="user-info-mobile d-block d-md-none">
                          <p class="mb-0" type="button">
                            Hello, {{ getInitials(userDetails?.Name) }}
                          </p>
                        </li> -->
                        <li *ngIf="this.userDetails.UserId > 0"
                          class="d-block d-md-none">
                          <a (click)="MyVideos()"
                            class="gap-5 d-flex align-items-center">
                            <span class="material-icons fs-20 rotate-0">
                              videocam
                            </span> My Videos</a>
                        </li>

                        <li class="d-block d-md-none cursor-pointer"
                          *ngIf="sharedService.isUserASeller">
                          <a (click)="redirectToSellerConsole()"
                            class="gap-5 d-flex align-items-center">
                            <span class="material-icons fs-20 rotate-0">
                              payments
                            </span>
                            Seller Console</a>
                        </li>
                        <li class="d-block d-md-none cursor-pointer">
                          <a routerLink="/user/contactus"
                            class="gap-5 d-flex align-items-center">
                            <span class="material-icons fs-20 rotate-0">
                              email
                            </span>
                            Contact Us</a>
                        </li>
                        <li *ngIf="this.userDetails.UserId > 0"
                          (click)="Logout()">
                          <a class="gap-5 d-flex align-items-center "> <span
                              class="material-icons fs-20 rotate-0">
                              logout
                            </span> Sign Out</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>